/* eslint-disable react/jsx-props-no-spreading */
import BookShelfLoading from "components/svgs/BookShelfLoading";

type Props = {
  className?: string;
};

export default function LoadingBook({ className = "", ...rest }: Props) {
  return (
    <div className="my-8 py-4">
      <BookShelfLoading
        {...rest}
        className={`w-20 h-20 overflow-visible mx-auto ${className}`}
      />
    </div>
  );
}
